export default __webpack_public_path__ + "static/media/Icon_filter_active.737bffa9.svg";